/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Search_PhInputs */

const vi_cdo_search_ph = /** @type {(inputs: Cdo_Search_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm mã đơn / người nhận / SĐT`)
};

/**

* @param {Cdo_Search_PhInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_search_ph = /** @type {((inputs?: Cdo_Search_PhInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Search_PhInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_search_ph(inputs)
});